import { render, staticRenderFns } from "./riskConfirmDialog.vue?vue&type=template&id=cc5c5bfe&scoped=true"
import script from "./riskConfirmDialog.vue?vue&type=script&lang=js"
export * from "./riskConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./riskConfirmDialog.vue?vue&type=style&index=0&id=cc5c5bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5c5bfe",
  null
  
)

export default component.exports